import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-gray-700 font-bold text-xl" }
const _hoisted_2 = { class: "text-gray-500 text-sm tracking-wider self-baseline ml-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"8px"} }, "Upload", -1)
const _hoisted_5 = {
  key: 1,
  class: "flex-col flex"
}
const _hoisted_6 = { class: "mt-4 text-gray-700" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, null, {
    title: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.uploadMediaTypeKorean), 1),
      _createElementVNode("span", _hoisted_2, " *변환할 " + _toDisplayString(_ctx.uploadMediaTypeKorean) + "를 업로드 하세요. ", 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_upload, {
        "list-type": "picture-card",
        accept: _ctx.uploadMediaType,
        "show-upload-list": false,
        "before-upload": _ctx.beforeUpload
      }, {
        default: _withCtx(() => [
          (!_ctx.targetFaceUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (!_ctx.isUploading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_PlusOutlined),
                      _hoisted_4
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_LoadingOutlined),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.progress) + "%", 1)
                    ]))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.mediaType === 'image')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.targetFaceUrl,
                      alt: "targetFace",
                      class: "h-full object-cover"
                    }, null, 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock("video", {
                      key: 1,
                      class: "h-full object-cover",
                      src: _ctx.targetFaceUrl,
                      autoplay: "",
                      loop: ""
                    }, null, 8, _hoisted_8))
              ], 64))
        ]),
        _: 1
      }, 8, ["accept", "before-upload"])
    ]),
    _: 1
  }))
}